/**
 * Central config — auto-switches between local dev and production.
 * 
 *  Local:      http://localhost:8082
 *  Production: https://xevytemail.xevyte.com
 */
const isProd = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

export const BACKEND_URL = isProd
    ? 'https://xevytemail.xevyte.com'
    : 'http://localhost:8082';

export const API_BASE = `${BACKEND_URL}/api`;

export const FRONTEND_URL = isProd
    ? 'https://xevytemail.xevyte.com'
    : 'http://localhost:3000';

export const ADMIN_URL = isProd
    ? 'https://xevytemailadmin.xevyte.com'
    : 'http://localhost:3001';
